import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { signOut, type SessionUser } from '../../auth/session';
import { errorMessage } from '../../lib/api';
import { browserTimeZone } from '../../lib/dates';
import { KeyValue } from './KeyValue';
import styles from './settings.module.css';

export function emailLabel(email: string): string {
  return email.endsWith('.painpal.invalid') ? 'Signed in with Strava' : email;
}

export function timezoneLabel(timezone: string | null): string {
  return timezone === null ? `${browserTimeZone()} · from your browser` : `${timezone} · saved at sign-up`;
}

export function AccountCard({ user }: { user: SessionUser }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const signOutRequest = useMutation({
    mutationFn: signOut,
    onSuccess: async () => {
      queryClient.clear();
      await navigate({ to: '/sign-in' });
    },
  });
  return (
    <section className={styles.card} aria-labelledby="account-title">
      <h2 id="account-title" className={styles.cardTitle}>ACCOUNT</h2>
      <dl className={styles.kvList}>
        <KeyValue k="NAME" v={user.name} />
        <KeyValue k="EMAIL" v={emailLabel(user.email)} />
        <KeyValue k="TIME ZONE" v={timezoneLabel(user.timezone)} />
      </dl>
      <button type="button" className="btn btn-outline" disabled={signOutRequest.isPending} onClick={() => signOutRequest.mutate()}>SIGN OUT</button>
      {signOutRequest.isError && <p role="alert" className={`alert-hot ${styles.formError}`}>{errorMessage(signOutRequest.error)}</p>}
    </section>
  );
}
